import { AlertTriangle } from "lucide-react";

import type { DeletedCharacteristicLine } from "@/lib/order-check";

/**
 * Плашка «характеристика строки заказа помечена на удаление в 1С».
 *
 * Прод 02.10.2026, заказ НФНФ-000640: две строки шли с собственной
 * характеристикой товара «ОПТ», помеченной на удаление, а штрихкод короба и
 * весь остаток — под действующей общей «ОПТ». Такую строку не собрать: каждый
 * скан честно отбивается «не та характеристика». Говорим об этом сразу при
 * открытии заказа, а не на первом скане. Работу по остальным строкам не
 * блокируем — чинится это правкой заказа в 1С.
 */
export function DeletedCharacteristicBanner({ lines }: { lines: DeletedCharacteristicLine[] }) {
  if (lines.length === 0) return null;
  return (
    <div
      role="alert"
      className="shrink-0 border-b-2 border-red-500 bg-red-50 px-3 py-2 text-xs text-red-900"
    >
      <div className="flex items-center gap-1.5 font-semibold">
        <AlertTriangle className="size-4 shrink-0 text-red-700" />
        Характеристика помечена на удаление в 1С — исправьте в 1С до сборки
      </div>
      <ul className="mt-1 space-y-0.5 pl-5">
        {lines.map((l) => (
          <li key={`${l.article}|${l.name}|${l.characteristic}`}>
            <span className="font-semibold">{l.article || l.name}</span> — «{l.characteristic}»
          </li>
        ))}
      </ul>
      <div className="mt-1 pl-5 text-[11px] text-red-800">
        Эти строки не соберутся: штрихкоды и остаток — под действующей характеристикой.
        Остальные строки собирать можно.
      </div>
    </div>
  );
}
